import React from "react";
import { Row, Col } from 'reactstrap';
import { Empty } from 'antd';

import { Collapse } from 'antd';

const { Panel } = Collapse;

const FAQComponent = ({ props }) => {
    return (
      <div className="main-wrapper faq-page">
        {/* Faq Area */}
        <section className="faq-area">
          <div className="custom-container">
            <h1 className="text-center pb-4">Frequently Asked Questions</h1>
            <Row>
              <Col md="12">
                <Row>
                  {props?.data?.data?.length !== 0 ? (
                    props?.data?.data?.map((data, i) => (
                      <Col md="6" key={i}>
                        <div className="faq-item shadow-sm border">
                          <Collapse className="bg-white border-0">
                            <Panel
                              className="border-0 p-2"
                              header={
                                <div className="faq-title d-flex">
                                  <div className="title-icon">
                                    <span>{i + 1}</span>
                                  </div>
                                  <div className="title-text">
                                    <p>{data?.question}</p>
                                  </div>
                                </div>
                              }
                              key={i}
                            >
                              <div className="faq-desc">
                                <p>{data?.answer}</p>
                              </div>
                            </Panel>
                          </Collapse>
                        </div>
                      </Col>
                    ))
                  ) : (
                    <Empty />
                  )}
                </Row>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
}

export default FAQComponent;